import { createFileRoute } from '@tanstack/react-router';

import { ZoneCreatePage } from '../modules/zones/ui/pages/ZoneCreatePage';

export const Route = createFileRoute('/_authenticated/dashboard/locations/$locationId/zones/new')({
  component: ZoneCreatePage,
  staticData: {
    breadcrumb: ['Manage', 'Locations', 'Zones', 'New'],
  },
});
